<template>
  <div id="contenedor-listado-proyecto-documentos-listado">
    <v-list
      nav
      three-line
      height="150px"
      class="overflow-y-auto"
      style="min-height: 320px;">
      <template v-for="documento in getProyectoDocumentos">
        <template>
          <v-hover v-slot="{ hover }" :key="`hover-${documento.datosArchivo.name}`">
            <v-list-item
              :key="documento.datosArchivo.name"
              class="my-0 mx-0"
              :class="{'grey lighten-4': hover}">
              <v-list-item-avatar>
                <v-icon>
                  {{ $iconoDeExtension(documento.datosArchivo.extension) }}
                </v-icon>
                </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                {{ documento.proyectoDocumentoTipo.descripcion }}
              </v-list-item-title>
              <v-list-item-subtitle class="caption">
                {{ $moment(documento.fecha).format('DD/MM/YYYY') }} -
                <span>
                  <FechaHumano :fecha="documento.createdAt"></FechaHumano>
                </span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ documento.descripcion }}
              </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <div class="d-flex">
                  <div>
                    <v-btn
                    @click="mixDescargarDocumento(documento.datosArchivo)"
                    :loading="descargandoArchivo"
                    icon>
                      <v-icon color="success">mdi-download-box</v-icon>
                    </v-btn>
                  </div>
                  <div>
                    <v-btn
                    @click="verInformacionDocumento(documento)"
                    icon>
                      <v-icon color="blue">mdi-information-box</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-list-item-action>
            </v-list-item>
          </v-hover>
        </template>
      </template>
    </v-list>
    <v-dialog
    v-if="esteDocumento"
    v-model="mostrarVentanaInformacionDocumento"
    width="400">
    <informacion-documento
    :proyectoDocumento="esteDocumento"
    v-on:cerrar="cerrarVentana">
    </informacion-documento>

    </v-dialog>
  </div>
</template>

<script>
import PROYECTO_DOCUMENTOS from '@/graphql/querys/administracion/control-proyectos/documentos/proyectoDocumentos.gql';
import FechaHumano from '@/components/FechaHumano.vue';
import InformacionDocumento from './Informacion.vue';
import mixProyectosDocumentos from '../mixProyectosDocumentos';

export default {
  name: 'ProyectoDocumentosListado',
  props: {
    idProyecto: {
      type: String,
      required: true,
    },
  },
  mixins: [mixProyectosDocumentos],
  components: {
    InformacionDocumento,
    FechaHumano,
  },
  apollo: {
    proyectoDocumentos: {
      query: PROYECTO_DOCUMENTOS,
      variables() {
        return {
          idProyecto: this.idProyecto,
        };
      },
    },
  },
  data() {
    return {
      descargandoArchivo: false,
      mostrarVentanaInformacionDocumento: false,
      esteDocumento: null,
    };
  },
  methods: {
    async descargarDocumento(datosArchivo) {
      await this.mixDescargarDocumento(datosArchivo);
    },
    verInformacionDocumento(documento) {
      this.esteDocumento = documento;
      this.mostrarVentanaInformacionDocumento = true;
    },
    cerrarVentana() {
      this.mostrarVentanaInformacionDocumento = false;
      this.esteDocumento = null;
    },
  },
  computed: {
    getProyectoDocumentos() {
      if (!this.proyectoDocumentos) return [];
      const proyectoDocumentosFormateado = this.proyectoDocumentos.slice()
        .map((proyectoDocumento) => ({
          ...proyectoDocumento,
          datosArchivo: JSON.parse(proyectoDocumento.fileData),
        }));
      return proyectoDocumentosFormateado.filter(({ esUltimo }) => esUltimo);
    },
  },
};
</script>

<style lang="scss" scoped></style>
